
// user profile avatar button
window.jQuery(document).ready(function() {

  window.jQuery('#user_profile_avatar').on('change', function(ev) {
    const [file] = document.getElementById('user_profile_avatar').files
    if (file)
      document.getElementById('avatar_thumb').src = URL.createObjectURL(file)
    else
      console.log('No file found')
  })

  window.jQuery('#select_avatar, #avatar_thumb').click(function(e){
    e.preventDefault();
    e.stopImmediatePropagation();
    window.jQuery('#user_profile_avatar').trigger('click');
  })
})